import { Paper, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { CardInformation } from "../../../components/exports";
import { RootState } from "../../../slices/Store";

// updated
export default function ProjectDetailInfo() {
    const sharedState = useSelector((state: RootState) => state.shared);
    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );
    const projectDetail = projectDetailState.projectDetail;

    const phase = sharedState.baseInfo.phaseList.find(
        (c) => c.id === projectDetail.phaseId
    );
    const usageType = sharedState.baseInfo.usageTypes.find(
        (c) => c.id === projectDetail.usageTypeId
    );
    const structureType = sharedState.baseInfo.structureTypes.find(
        (c) => c.id === projectDetail.structureTypeId
    );

    return (
        <Paper sx={{ mb: 2 }}>
            <Stack spacing={1.25} sx={{ p: 2 }}>
                <CardInformation
                    title="کارفرما"
                    value={projectDetail?.receptor}
                />
                <CardInformation title="مرحله" value={phase?.title} />
                <CardInformation
                    title="نوع سازه"
                    value={structureType?.title}
                />
                <CardInformation title="نوع کاربری" value={usageType?.title} />
                <CardInformation title="طبقه" value={projectDetail.floors} />
                <CardInformation
                    title="طبقه منفی"
                    value={projectDetail.subFloors}
                />
                <CardInformation title="واحد" value={projectDetail.units} />
                <CardInformation
                    title="متراژ"
                    value={projectDetail.groundArea}
                />
                <CardInformation
                    title="زیربنا"
                    value={projectDetail.residentialArea}
                />
            </Stack>
        </Paper>
    );
}
